import { render, staticRenderFns } from "./VentanasEnturnamientoEstado.vue?vue&type=template&id=c494772e"
import script from "./VentanasEnturnamientoEstado.vue?vue&type=script&lang=js"
export * from "./VentanasEnturnamientoEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports